import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import { mapProps } from 'recompose';

import withModal from '../../../../../../../components/global/modal/withModal';
import CheckoutSuccessMain from './index';
import withVirtualPageview from '../../../../../../../components/global/hoc/withVirtualPageview';
import getAccount from '../../../../../graphql/queries/getAccount';

export const MEMBERSHIPS_CHECKOUT_SUCCESS_MODAL =
  'MEMBERSHIPS_CHECKOUT_SUCCESS_MODAL';

export default compose(
  withRouter,
  getAccount,
  mapProps(({ data, ...props }) => ({
    ...props,
    account: data.me,
  })),
  mapProps(({ onRequestClose, ...props }) => ({
    onClose: onRequestClose,
    ...props,
  })),
  withVirtualPageview({
    path: 'success',
    title: 'Checkout Success',
  }),
)(
  withModal(CheckoutSuccessMain, {
    name: MEMBERSHIPS_CHECKOUT_SUCCESS_MODAL,
    dismissible: false,
    type: 'full',
    size: 'sm',
    hideHeader: true,
    className: 'memberships-checkout-success-modal',
  }),
);
